// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-2090671c] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.table-wrapper .filter-wrapper[data-v-2090671c] {\n  width: 230px;\n}\n.table-wrapper .filter-wrapper .label[data-v-2090671c] {\n  min-width: 80px;\n}\n.table-wrapper .filter-wrapper .select-width[data-v-2090671c] {\n  width: 150px;\n}", ""]);
// Exports
module.exports = exports;
